import { RouteWrapper, Subtitle } from '@/views/CrehanaLegal/components';

const AuthorizationForProcessingPersonalDataATS = () => (
  <RouteWrapper>
    <section>
      <p>
        <strong>El Cliente,</strong> en calidad de
        <strong> responsable del tratamiento,</strong>y{' '}
        <strong>Crehana, </strong>
        como proveedor tecnológico que ofrece la plataforma de gestión
        documental y actúa como <strong>encargado del tratamiento,</strong>{' '}
        informan que los datos personales solicitados serán tratados conforme a
        los principios de
        <strong>
          {' '}
          legalidad, confidencialidad, integridad, finalidad y proporcionalidad,
        </strong>{' '}
        en cumplimiento de las normas de protección de datos personales vigentes
        en{' '}
        <strong>
          Colombia (Ley 1581 de 2012 y Decreto 1377 de 2013), México (Ley
          Federal de Protección de Datos Personales en Posesión de los
          Particulares), Perú (Ley N.º 29733 y su Reglamento aprobado por
          Decreto Supremo N.º 003-2013-JUS), Argentina (Ley 25.326) y Chile (Ley
          19.628),
        </strong>{' '}
        así como cualquier otra normativa aplicable en jurisdicciones donde se
        lleven a cabo operaciones o transferencias internacionales de datos,
        incluyendo, de ser pertinente, el
        <strong>
          {' '}
          Reglamento General de Protección de Datos (GDPR) de la Unión Europea
        </strong>{' '}
        y demás estándares equivalentes que garanticen la adecuada protección de
        la información.
      </p>
      <br />
      <Subtitle>1. Finalidad del tratamiento</Subtitle>
      <p>
        La recolección y tratamiento de los datos personales, incluyendo pero no
        limitándose a hojas de vida, historial académico, historial médico
        ocupacional, referencias laborales, documentos de identificación y demás
        soportes requeridos, tiene como finalidad gestionar procesos de
        selección, evaluación, vinculación, verificación de antecedentes,
        cumplimiento de requisitos legales y regulatorios, y demás actividades
        inherentes a la administración de personal
      </p>
      <p>
        Crehana almacenará los datos únicamente durante el tiempo necesario para
        que el cliente responsable tome la decisión de contratación, conservando
        de forma limitada las hojas de vida para alimentar bases de análisis y
        optimizar futuros procesos de selección, respetando la normativa
        aplicable.
      </p>
      <br />
      <Subtitle>2. Naturaleza de los datos</Subtitle>
      <p>
        El tratamiento podrá incluir datos de identificación, datos de contacto,
        información laboral, académica y, de manera excepcional, datos sensibles
        como información médica ocupacional, estrictamente necesaria para
        verificar la idoneidad del cargo, de acuerdo con las leyes de protección
        de datos personales vigentes en cada país.
      </p>
      <br />
      <Subtitle>3. Carácter facultativo de la información sensible</Subtitle>
      <p>
        La entrega de datos sensibles es facultativa y no condicionará la
        participación en el proceso de selección, salvo que sean estrictamente
        necesarios para el cumplimiento de obligaciones legales o contractuales
        derivadas de la vacante ofertada.
      </p>
      <br />
      <Subtitle>4. Derechos del titular</Subtitle>
      <p>
        Como titular de los datos personales, usted podrá en cualquier momento
        acceder, actualizar, rectificar, suprimir o revocar la autorización
        otorgada para el tratamiento de sus datos personales, así como solicitar
        información sobre el uso que se les ha dado. Estos derechos podrán
        ejercerse conforme a la legislación aplicable en su país, a través de
        los canales dispuestos por:
      </p>
      <ul>
        <li>
          <strong>Crehana</strong> exclusivamente para consultas relacionadas
          con su rol como encargado del tratamiento, en{' '}
          <strong>gestion.datospersonales@crehana.com</strong>
        </li>
      </ul>
      <br />
      <Subtitle>5. Medidas de seguridad</Subtitle>
      <p>
        El responsable y el encargado del tratamiento han implementado medidas
        técnicas, administrativas y organizativas para proteger los datos
        personales contra pérdida, alteración, uso indebido, acceso no
        autorizado o divulgación, garantizando la confidencialidad, integridad y
        disponibilidad de la información tratada.
      </p>
      <br />
      <Subtitle>6. Transferencias y transmisiones internacionales</Subtitle>
      <p>
        En caso de ser necesario transferir o almacenar datos en otros países,
        se garantizará el cumplimiento de niveles adecuados de protección
        conforme a la normativa vigente en Colombia, México, Perú, Argentina y
        Chile.
      </p>
      <br />
      <Subtitle>7. Vigencia de la autorización</Subtitle>
      <p>
        Esta autorización tendrá vigencia desde el momento de su aceptación y
        por el tiempo necesario para cumplir las finalidades descritas, o
        mientras exista una relación contractual, legal o de negocio que lo
        justifique, respetando siempre los plazos de conservación definidos por
        la normativa de cada país.
      </p>
    </section>
  </RouteWrapper>
);

export default AuthorizationForProcessingPersonalDataATS;
